// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nUxC","question":"styles_question__36uyX","description":"styles_description__1zeMK"};